export default class PreferredAccessibleFormat {
  preferredAccessibleFormatId: string;
  preferredAccessibleFormatCode: string;
  preferredAccessibleFormatName: string;
  obsoleteFlag: boolean;
  obsoleteDate: Date;

  constructor(preferredAccessibleFormat?) {
    if (preferredAccessibleFormat) {
      this.preferredAccessibleFormatId = preferredAccessibleFormat.preferredAccessibleFormatId;
      this.preferredAccessibleFormatCode = preferredAccessibleFormat.preferredAccessibleFormatCode;
      this.preferredAccessibleFormatName = preferredAccessibleFormat.preferredAccessibleFormatName;
      this.obsoleteFlag = preferredAccessibleFormat.obsoleteFlag;
      this.obsoleteDate = preferredAccessibleFormat.obsoleteDate ? new Date(preferredAccessibleFormat.obsoleteDate) : null;
    }
  }

}
